import { render, staticRenderFns } from "./AppDrawer.vue?vue&type=template&id=38d54da2&scoped=true&"
import script from "./AppDrawer.vue?vue&type=script&lang=ts&"
export * from "./AppDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./AppDrawer.vue?vue&type=style&index=0&id=38d54da2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d54da2",
  null
  
)

export default component.exports